// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + {"1166":"f71da141","2167":"cecd2f6c"}[chunkId] + "." + {"1166":"5ae1ac7c7c151fe6","2167":"5e5897f5079f7b75"}[chunkId] + ".js";
};